import React from 'react';
import { Award, Shield, Heart } from 'lucide-react';
import Breadcrumbs from '@/components/Breadcrumbs';
import Footer from '@/components/Footer';
import ShopifyBuyButton from '@/components/ShopifyBuyButton';

const TennisSocks = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 mt-4">
        <Breadcrumbs />
      </div>

      <div className="container mx-auto px-4 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-start">

          {/* Product Image */}
          <div className="relative">
            <div className="lg:sticky lg:top-8 space-y-4 sm:space-y-6 lg:space-y-8">
              <div className="bg-card border border-border rounded-lg p-4 sm:p-6 lg:p-8">
                <img src="/lovable-uploads/987cc678-2409-4e5c-a53f-2e3178f82fe5.png" alt="PrimeFlex Tennissokker (10-pakning)" className="w-full rounded-lg shadow-lg hover:scale-105 transition-transform duration-500" />
              </div>

              <div className="bg-muted border border-border p-4 sm:p-6 lg:p-8 rounded-lg">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-lg sm:text-2xl">🏆</span>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-orbit font-semibold text-foreground mb-2 sm:mb-3">
                      Sammenlign og se forskjellen
                    </h3>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      Vi oppfordrer deg til å sammenligne våre produkter med andre aktører når det gjelder kvalitet,
                      pris og innhold - for vi er faktisk best! Test gjerne forskjellen selv og opplev hvorfor våre
                      kunder velger oss gang på gang.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Product Details */}
          <div className="space-y-4 sm:space-y-6 lg:space-y-8">
            <div className="text-center lg:text-left">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-orbit font-bold text-foreground mb-3 sm:mb-4">Peveo Tennissokker</h1>
              <div className="bg-primary p-3 sm:p-4 rounded-lg mb-4 sm:mb-6">
                <p className="text-xl sm:text-2xl lg:text-3xl font-orbit font-bold text-primary-foreground">10-PAKNING</p>
                <p className="text-sm sm:text-base lg:text-lg text-primary-foreground/80">10 par premium tennissokker inkludert</p>
              </div>
              <div className="flex items-center gap-2 justify-center lg:justify-start mb-4 sm:mb-6">
                <div className="h-1 w-12 sm:w-16 bg-primary rounded-full"></div>
                <span className="text-sm sm:text-base text-primary font-semibold">Premium Kvalitet</span>
                <div className="h-1 w-12 sm:w-16 bg-primary rounded-full"></div>
              </div>
            </div>

            <div className="py-1">
              <ShopifyBuyButton productId="9358249656551" componentId="product-component-tennis-socks-page" domain="6pjebd-jw.myshopify.com" storefrontAccessToken="24c563b5bb4fa1b2d3b84fcb8e32090c" className="w-full" />
            </div>

            <div className="bg-card border border-border rounded-lg p-4 sm:p-6 lg:p-8">
              <p className="text-sm sm:text-base lg:text-lg leading-relaxed text-muted-foreground mb-6 sm:mb-8">
                Opplev den ultimate komforten og ytelsen med våre PrimeFlex Tennissokker - pakket i praktisk 10-pakning!
                Designet spesielt for tennis og andre høyintensive aktiviteter, kombinerer disse sokkene avanserte materialer
                med ergonomisk design for optimal prestasjon på banen.
              </p>

              <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mb-6 sm:mb-8">
                <div className="bg-muted border border-border p-4 sm:p-6 rounded-lg text-center group hover:shadow-md transition-all duration-300">
                  <Award className="mx-auto mb-3 sm:mb-4 text-primary group-hover:scale-110 transition-transform duration-300" size={32} />
                  <h3 className="font-orbit font-semibold mb-2 sm:mb-3 text-foreground text-sm sm:text-base">Premium Kvalitet</h3>
                  <p className="text-xs sm:text-sm text-muted-foreground">Høykvalitets materialer for maksimal holdbarhet</p>
                </div>

                <div className="bg-muted border border-border p-4 sm:p-6 rounded-lg text-center group hover:shadow-md transition-all duration-300">
                  <Shield className="mx-auto mb-3 sm:mb-4 text-primary group-hover:scale-110 transition-transform duration-300" size={32} />
                  <h3 className="font-orbit font-semibold mb-2 sm:mb-3 text-foreground text-sm sm:text-base">Optimal Støtte</h3>
                  <p className="text-xs sm:text-sm text-muted-foreground">Ergonomisk design som støtter fotens naturlige form</p>
                </div>

                <div className="bg-muted border border-border p-4 sm:p-6 rounded-lg text-center group hover:shadow-md transition-all duration-300 sm:col-span-2 lg:col-span-1">
                  <Heart className="mx-auto mb-3 sm:mb-4 text-destructive group-hover:scale-110 transition-transform duration-300" size={32} />
                  <h3 className="font-orbit font-semibold mb-2 sm:mb-3 text-foreground text-sm sm:text-base">Komfort</h3>
                  <p className="text-xs sm:text-sm text-muted-foreground">Myk og pustende for langvarig komfort</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TennisSocks;
